// eslint-disable-next-line import/no-cycle
import User from './User';
import Website from './Website';
import Mail from './Mail';
import Inventory from './Inventory';

// https://vuex.vuejs.org/guide/modules.html
export default {
    User,
    Website,
    Mail,
    Inventory,
};
